import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input } from "../../../components/form";
import { Button } from "../../../components/button";

interface IProductForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const ProductForm: React.FC<IProductForm> = ({
  loading,
  form,
  submit,
}) => {
  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Input
          label="Nom"
          className="w-full"
          {...form.register("name", { required: "Nom requis" })}
          placeholder="Nom du produit"
        />
        <Input
          label="URL"
          className="w-full"
          {...form.register("url", { required: "URL requise" })}
          placeholder="https://..."
        />
        <Input
          label="Image (URL)"
          className="w-full"
          {...form.register("imgUrl", { required: "Image requise" })}
          placeholder="https://..."
        />
        <Input
          label="Référence"
          className="w-full"
          {...form.register("reference", { required: "Référence requise" })}
          placeholder="REF-001"
        />
        <Input
          label="Dernier prix"
          type="number"
          step="0.01"
          className="w-full"
          {...form.register("lastPrice", { required: true, valueAsNumber: true })}
        />
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
